export default __webpack_public_path__ + "static/media/pyc2.dd416d51.png";